<template>
	<div :class="['beian-footer', theme === 'dark' ? 'beian-dark' : 'beian-light']">
		<a class="beian-link" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
			皖ICP备2026028721号-3
		</a>
		<a class="beian-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=34019202003210"
			target="_blank" rel="noopener noreferrer">
			<img class="beian-icon" :src="policeIcon" alt="公安备案图标" />
			<span>皖公网安备34019202003210号</span>
		</a>
	</div>
</template>

<script>
	export default {
		name: 'BeianFooter',
		props: {
			// light：浅色背景用（主框架）；dark：深色背景用（登录页渐变底）
			theme: {
				type: String,
				default: 'light'
			}
		},
		computed: {
			policeIcon() {
				return require('@/assets/ghs.png')
			}
		}
	}
</script>

<style scoped>
	.beian-footer {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		gap: 4px 20px;
		font-size: 12px;
		line-height: 20px;
	}

	.beian-link {
		display: inline-flex;
		align-items: center;
		text-decoration: none;
		transition: color 0.2s;
	}

	.beian-icon {
		width: 16px;
		height: 16px;
		margin-right: 4px;
		display: block;
	}

	.beian-light .beian-link {
		color: #909399;
	}

	.beian-light .beian-link:hover {
		color: #409eff;
	}

	.beian-dark .beian-link {
		color: rgba(255, 255, 255, 0.75);
	}

	.beian-dark .beian-link:hover {
		color: #ffffff;
	}
</style>
